import React, { useState } from "react";
import { enterFullScreen, exitFullScreen } from "../../utils";
import { FullscreenOutlined, FullscreenExitOutlined } from "@ant-design/icons";
import { moduleConfig } from "../../config";
import "./index.less";
const Index = ({ currentDigitalType }) => {
  const [isFullScreen, setIsFullScreen] = useState(false); // 全屏状态
  // 全屏控制
  const toggleFullScreen = () => {
    if (!isFullScreen) {
      enterFullScreen(setIsFullScreen);
    } else {
      exitFullScreen(setIsFullScreen);
    }
  };

  return (
    <>
      {moduleConfig.logo && (
        <h1 className="AiDigitalTitle">
          <img
            src="https://kechuangyun-static-1304630716.cos.ap-beijing.myqcloud.com/aiDiaital/logo.webp"
            style={{ width: "24vw" }}
            alt=""
          />
        </h1>
      )}
      {moduleConfig.modeChange && (
        <div className="AiDigitalCurrentTyoe">{`${
          currentDigitalType || ""
        }`}</div>
      )}

      <div
        className="AiDigitalScreen"
        onClick={() => {
          toggleFullScreen();
        }}
      >
        {isFullScreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
      </div>
    </>
  );
};

export default Index;
